<div class="space-y-6">
  <div class="flex items-center justify-between">
    <h1 class="text-2xl font-bold text-gray-900">User Management</h1>
    <app-button variant="primary" (clicked)="openAddModal()">
      <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      Add User
    </app-button>
  </div>

  <div class="card overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">User</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Department</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contact</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          @if (users().length === 0) {
            <tr>
              <td colspan="6" class="px-6 py-8 text-center text-gray-500">No users found</td>
            </tr>
          } @else {
            @for (user of users(); track user.id) {
              <tr class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-semibold mr-3">
                      {{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}
                    </div>
                    <div>
                      <div class="text-sm font-medium text-gray-900">{{ user.firstName }} {{ user.lastName }}</div>
                      <div class="text-sm text-gray-500">{{ user.email }}</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                    {{ user.role }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ user.department || 'N/A' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ user.phone }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="px-2 py-1 text-xs font-medium rounded-full"
                        [ngClass]="{
                          'bg-green-100 text-green-800': user.isActive,
                          'bg-red-100 text-red-800': !user.isActive
                        }">
                    {{ user.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button (click)="openEditModal(user)" class="text-primary-600 hover:text-primary-900 mr-4">Edit</button>
                  <app-button variant="danger" (clicked)="deleteUser(user.id)">Delete</app-button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  @if (showModal()) {
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (click)="closeModal()">
      <div class="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4" (click)="$event.stopPropagation()">
        <div class="p-6 border-b">
          <h2 class="text-xl font-semibold text-gray-900">
            {{ editingUser() ? 'Edit User' : 'Add New User' }}
          </h2>
        </div>
        <div class="p-6 space-y-4">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <app-input
                label="First Name"
                type="text"
                [(ngModel)]="userForm().firstName">
              </app-input>
            </div>
            <div>
              <app-input
                label="Last Name"
                type="text"
                [(ngModel)]="userForm().lastName">
              </app-input>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <app-input
                label="Email"
                type="email"
                [(ngModel)]="userForm().email">
              </app-input>
            </div>
            <div>
              <app-input
                label="Phone"
                type="tel"
                [(ngModel)]="userForm().phone">
              </app-input>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Role</label>
              <select [(ngModel)]="userForm().role" class="input-field">
                <option value="Admin">Admin</option>
                <option value="Doctor">Doctor</option>
                <option value="Nurse">Nurse</option>
                <option value="Receptionist">Receptionist</option>
                <option value="Pharmacist">Pharmacist</option>
              </select>
            </div>
            <div>
              <app-input
                label="Department"
                type="text"
                [(ngModel)]="userForm().department">
              </app-input>
            </div>
          </div>
          @if (userForm().role === 'Doctor') {
            <div>
              <app-input
                label="Specialization"
                type="text"
                [(ngModel)]="userForm().specialization">
              </app-input>
            </div>
            <div>
              <app-input
                label="License Number"
                type="text"
                [(ngModel)]="userForm().licenseNumber">
              </app-input>
            </div>
          }
        </div>
        <div class="p-6 border-t flex justify-end space-x-3">
          <app-button variant="secondary" (clicked)="closeModal()">Cancel</app-button>
          <app-button variant="primary" (clicked)="saveUser()">Save</app-button>
        </div>
      </div>
    </div>
  }
</div>

